import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

export default function Reviews() {
  // Hand-picked top-tier reviews from your list for maximum impact
  const topReviews = [
    { 
      name: "Saksham Gosain", 
      text: "One of the few academies in Gurgaon that provides Olympic-level shooting training with a professional setup. The coach focuses on each student’s progress. The name says it all — Mission Olympic!", 
      color: "bg-red-600",
      tag: "Olympic Aspirant"
    },
    { 
      name: "Jyoti Yadav", 
      text: "Amazing Range with amazing environment and a keen experience of taking shooting classes under the Coaches that lead students in the right directions.", 
      color: "bg-gold text-black",
      tag: "Advanced Marksman"
    },
    { 
      name: "Rahul Yadav", 
      text: "Absolutely the best shooting academy in Manesar, Gurgaon! The coaches are highly experienced and supportive. Training focuses on accuracy, mindset, and discipline.", 
      color: "bg-zinc-700",
      tag: "Professional Shooter"
    },
    { 
      name: "Piyush", 
      text: "Even if you’re a beginner, the coaches guide you step by step. I had no prior experience, but now I can shoot with full confidence! Definitely the best shooting range near me.", 
      color: "bg-red-700",
      tag: "Beginner Graduate"
    },
    { 
      name: "KING AJAY", 
      text: "Brilliant academy for 10m air pistol and rifle. Coaches and staff are very supportive. I recommend everyone visit to boost your shooting skills.", 
      color: "bg-zinc-800",
      tag: "Pistol Specialist"
    },
    { 
      name: "Naveen Kumar", 
      text: "Focuses on technical and mental training with modern facilities. Chaitanya Shooting Academy is a great choice for anyone looking to enhance their abilities.", 
      color: "bg-gold text-black",
      tag: "Technical Trainee"
    }
  ];

  return (
    <section id="reviews" className="py-24 bg-black overflow-hidden border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 mb-16">
        <div className="flex flex-col md:flex-row justify-between items-end gap-6">
          <div className="gsap-fade-up">
            <p className="text-red-600 font-bold tracking-[0.4em] uppercase text-[10px] mb-2">Wall of Fame</p>
            <h2 className="font-heading text-5xl md:text-7xl font-black italic uppercase leading-[0.9] text-white">
              WHAT <span className="text-red-600">CHAMPIONS</span> SAY
            </h2>
          </div>
          
          {/* Professional Trust Badge */}
          <div className="flex items-center gap-3 bg-zinc-900/50 px-6 py-3 rounded-full border border-white/10 backdrop-blur-md">
            <span className="text-gold font-heading text-2xl leading-none">5.0</span>
            <div className="flex text-gold">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" />)}
            </div>
            <span className="text-zinc-500 text-[10px] uppercase font-black tracking-widest ml-2">100+ Verified Reviews</span>
          </div>
        </div>
      </div>

      {/* INFINITE MARQUEE ROW - Ultra Smooth Professional Animation */}
      <div className="flex overflow-hidden">
        <motion.div 
          initial={{ x: 0 }}
          animate={{ x: "-50%" }}
          transition={{ duration: 35, repeat: Infinity, ease: "linear" }}
          className="flex gap-8 whitespace-nowrap"
        >
          {/* Doubling the array to create a seamless infinite scroll loop */}
          {[...topReviews, ...topReviews].map((r, i) => (
            <div 
              key={i} 
              className="w-[380px] md:w-[500px] flex-shrink-0 bg-zinc-900/30 p-10 rounded-[2.5rem] border border-white/5 relative group hover:border-red-600/30 transition-all duration-500"
            >
              <Quote className="text-white/5 absolute top-8 right-8 w-16 h-16 group-hover:text-red-600/10 transition-colors" />
              
              <div className="flex text-gold mb-6">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" />)}
              </div>

              <p className="text-base md:text-lg text-zinc-200 italic whitespace-normal leading-relaxed mb-8 relative z-10 font-medium">
                "{r.text}"
              </p>

              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-black text-sm shadow-xl ${r.color}`}>
                  {r.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-white uppercase italic tracking-tight leading-none">
                    {r.name}
                  </h3>
                  <p className="text-[9px] text-zinc-400 uppercase tracking-[0.3em] font-bold mt-1">
                    {r.tag}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
      
      {/* Bottom CTA for trust */}
      <div className="text-center mt-12">
        <p className="text-zinc-700 text-[10px] uppercase tracking-[0.6em] font-bold">
          Trusted by Athletes Across Haryana
        </p>
      </div>
    </section>
  );
}